<template>
  <div class="" @scroll="handleScroll">
    <div
      v-if="flags.isFetching"
      class="async-loader-screen -helper--flex align-center justify-center"
    >
      <v-progress-circular
        :size="80"
        color="#0E5CF4"
        indeterminate
      ></v-progress-circular>
    </div>

    <div style="background-color: white !important" class="welcome-wrapper">
      <div class="welcome-view welcome-partner-form-view">
        <div
          class="ob-step-container"
          :style="
            !flags.isPartnerFlow && !isMobile && 'padding-top: 70px !important'
          "
        >
          <div
            class="welcome-logos-wrapper"
            :class="flags.isPartnerFlow && 'welcome-logos-wrapper-partner'"
          >
            <span class="main-logo-dark-blue" />
            <img
              v-if="partnerLogo"
              class="partner-plus"
              src="../RF_assets/icons/plus-blue.svg"
              alt="+"
            />

            <img
              v-if="partnerLogo"
              alt="partner-logo"
              class="partner-logo"
              :src="partnerLogo"
            />
          </div>
          <h2 v-html="heroContent"></h2>
          <h2 class="header-line2">
            {{ $t('notice.headerLine2PartnerView') }}
          </h2>
          <HeroIcons v-if="false" :data="heroIconsData" />
          <v-form
            id="v-form"
            ref="form"
            class="-helper--flex column"
            :class="isPartnerFlow && 'form-partner'"
            @submit.prevent="submitForm"
          >
            <v-text-field
              v-if="flags.isPartnerFlow"
              id="firstName"
              v-model="customer.firstName"
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="given-name"
              :rules="firstNameRules"
              :error-messages="formFieldsErrors.firstName"
              @focus="clearFieldError('firstName')"
              @input="validateForm"
            >
              <template #label>
                <p class="input-legend">{{ $t('intro.firstName') }}</p>
              </template>
              <template #message="{ message, key }">
                <span id="firstNameMessage" :key="key" v-html="message"></span>
              </template>
            </v-text-field>

            <v-text-field
              v-if="flags.isPartnerFlow"
              id="lastName"
              v-model="customer.lastName"
              dense
              filled
              rounded
              validate-on-blur
              autocomplete="family-name"
              :rules="lastNameRules"
              :error-messages="formFieldsErrors.lastName"
              @focus="clearFieldError('lastName')"
              @input="validateForm"
            >
              <template #label>
                <p class="input-legend">{{ $t('intro.lastName') }}</p>
              </template>
              <template #message="{ message, key }">
                <span id="lastNameMessage" :key="key" v-html="message"></span>
              </template>
            </v-text-field>

            <v-text-field
              id="email"
              ref="emailInput"
              v-model="customer.email"
              dense
              filled
              rounded
              :readonly="flags.isEmailFieldReady"
              :rules="inputEmailRules"
              :error-messages="
                formFieldsErrors.email || formFieldsErrors.defaultError
              "
              type="email"
              autocomplete="username email"
              validate-on-blur
              @focus="clearFieldError('email')"
              @input="validateForm"
            >
              <template slot="label">
                {{ $t('intro.email') }}
              </template>
              <template #message="{ message, key }">
                <span id="emailMessage" :key="key" v-html="message"></span>
              </template>
            </v-text-field>

            <div class="fluid relative">
              <v-text-field
                id="password"
                v-model="customer.password"
                dense
                filled
                rounded
                validate-on-blur
                name="password"
                class="password"
                autocomplete="new-password"
                :type="flags.isPasswordShown ? 'text' : 'password'"
                :rules="passwordRules"
                :error-messages="
                  formFieldsErrors.password || formFieldsErrors.defaultError
                "
                :append-icon="flags.isPasswordShown ? 'Hide' : 'Show'"
                :append-outer-icon="icons.info"
                @focus="clearFieldError('password')"
                @input="validateForm"
                @click:append="flags.isPasswordShown = !flags.isPasswordShown"
                @click:append-outer="
                  flags.isPassToolTipShown = !flags.isPassToolTipShown
                "
              >
                <template slot="label">
                  {{ $t('intro.password') }}
                </template>
                <template #message="{ message, key }">
                  <span id="passwordMessage" :key="key" v-html="message"></span>
                </template>
              </v-text-field>
              <div
                v-show="!formFieldsErrors.password"
                id="passwordProgressBar-error"
                class="password-dif-indicator"
                :style="{
                  width: !customer.password ? '0%' : score.value,
                  backgroundColor: score.color,
                }"
              ></div>
              <ValidationToolTip
                v-if="flags.isPassToolTipShown"
                id="passwordToolTip"
                :data="validationToolTipData"
              />
            </div>

            <v-text-field
              v-if="false"
              id="referral"
              v-model="customer.referralCode"
              dense
              filled
              rounded
              validate-on-blur
              data-vv-name="referral"
              :error-messages="formFieldsErrors.referral"
              autocomplete="organization"
              @focus="clearFieldError('referral')"
            >
              <template slot="label">
                {{ $t('intro.referral') }}
              </template>
              <template #message="{ message }">
                <span id="referralMessage" v-html="message"></span>
              </template>
            </v-text-field>
            <div
              class="tnc-btn-wrapper partner-tnc-wrapper -helper--flex align-center column"
              :class="isPartnerFlow && 'tnc-btn-wrapper-partner'"
            >
              <span
                class="tnc-content partner-tnc-content -helper--flex align-center column"
              >
                <p>
                  By clicking GET STARTED you agree to Lili's
                  <a
                    id="termsOfUse"
                    href="https://lili.co/legal-documents/lili-terms-of-use"
                    target="_blank"
                    @click="handleAnchorClick('terms')"
                    >Terms of Use</a
                  >
                  and
                  <a
                    v-if="!isSunriseFlow"
                    id="termsAndConditions"
                    href="https://lili.co/legal-documents/choice-customer-agreement"
                    target="_blank"
                    @click="handleAnchorClick('terms')"
                    >Terms & Conditions</a
                  >{{ !isSunriseFlow ? ', ' : '' }}
                  <a
                    id="privacyPolicy"
                    href="https://lili.co/legal-documents/lili-privacy-policy"
                    target="_blank"
                    @click="handleAnchorClick('privacy')"
                    >Privacy Policy</a
                  >
                </p>
              </span>
              <v-btn
                id="elCta-partner"
                class="main-app-cta"
                :class="{
                  'active-cta': isCtaEnabled,
                }"
                elevation="0"
                :loading="flags.isLoaderShown"
                type="submit"
              >
                Get Started
              </v-btn>
            </div>
          </v-form>

          <div class="-helper--flex justify-center">
            <p
              class="resume-application"
              :class="isPartnerFlow && 'resume-application-partner'"
            >
              Already started?
              <span
                id="resumeob"
                style="
                  font-family: MetricRRegular;
                  font-size: 12px;
                  color: #0e5cf4;
                "
                @click="handleGetStarted"
              >
                Resume ongoing application
              </span>
            </p>
          </div>
          <InternalLink
            v-if="false"
            id="noPass"
            :content="$t('notice.notAFreelancer')"
            destination="/ob/noBusinessDone"
          />
          <div class="-helper--flex space-between align-center trust-container">
            <div class="-helper--flex align-center">
              <span class="banner-fdic-dark-gray" />
              <p class="footer-banner-content">
                {{
                  `Banking services provided by ${dynamicDisclaimer}, Member FDIC.`
                }}
              </p>
            </div>
            <span class="trust-pilot-dark-gray" />
          </div>
        </div>
        <VueRecaptcha
          id="recaptcha"
          ref="recaptcha"
          :sitekey="captchaSiteKey"
          :load-recaptcha-script="true"
          size="invisible"
          @verify="onVerify"
          @error="onCaptchaError"
        />
      </div>
      <div class="welcome-partner-details-view">
        <div class="partner-details-wrapper">
          <div
            class="feature-wrapper"
            :style="isDNB && !isMobile && 'padding-top: 108px !important'"
          >
            <div v-if="flags.isPartnerFlow" class="header">
              We’ve teamed up with {{ partnerName }} to streamline your business
              banking application process
            </div>
            <div v-if="!flags.isPartnerFlow" class="header">
              Bank smarter with the business checking account that any business
              needs
            </div>
            <div class="feature">
              <div class="name">Banking</div>
              <div class="description">
                Savings account with {{ APY }}% APY<sup>1</sup>, Lili Visa®
                Debit Card, no hidden fees, no overdraft fees, and no deposit or
                minimum balance required.
              </div>
            </div>
            <div class="feature">
              <div class="name">Accounting</div>
              <div class="description">
                Smart bookkeeping, instant transaction categorization, automated
                reports & insights,<br />
                bill management and invoicing software<sup>2</sup>.
              </div>
            </div>
            <div class="feature">
              <div class="name">Tax preparation</div>
              <div class="description">
                Automatic tax savings, write-off tracker, expense reports and
                pre-filled tax forms<sup>2</sup>.
              </div>
            </div>
            <div v-if="isDNB" class="feature">
              <div class="name">Potentially impact some of your D&B scores</div>
              <div class="description">
                Connect your Lili account with D&B Credit Insights and unlock
                the potential to impact your D&B Delinquency Score and D&B
                Failure Score<sup>3</sup>.
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="partner-footer">
            <div class="partner-footer-border"></div>
            <div id="disclaimer" class="text">
              {{
                `Lili is a financial technology company, not a bank. Banking services provided by ${dynamicDisclaimer}, Member FDIC`
              }}
            </div>
            <div class="text">
              <sup>1</sup> The Annual Percentage Yield (“APY”) for the Lili
              Savings Account is variable and may change at any time. The
              disclosed APY is effective as of {{ APY_EFFECTIVE_DATE }}. Must
              have at least $0.01 in savings to earn interest. The APY applies
              to balances of up to and including $1,000,000. Any portions of a
              balance over $1,000,000 will not earn interest or have a yield.
              Available to Lili Pro, Lili Smart, and Lili Premium account
              holders only.
            </div>
            <div class="text">
              <sup>2</sup> Available to Lili Smart and Lili Premium account
              holders only, applicable monthly account fee applies. Please refer
              to our Terms and Conditions for details.
            </div>
            <div v-if="isDNB" class="text">
              <sup>3</sup> By integrating your Lili Business Bank Account
              through the D&B Credit Insights banking integration feature, there
              may be potential for you to positively impact your Delinquency and
              Failure Scores. Dun & Bradstreet requires a minimum of six months
              of business banking transaction history to be able to potentially.
            </div>

            <div
              class="footer-patriot-act"
              :class="isMobile && 'mobile-footer-patriot-act'"
            >
              <!-- <div class="act-text"></div> -->
              <div class="act-title">USA PATRIOT Act notice</div>
              <div class="act-text">
                To help the government fight the funding of terrorism and money
                laundering activities, Federal law requires all financial
                institutions to obtain, verify, and record information that
                identifies each person who opens an account.
              </div>
              <div class="act-text">
                What this means for you: When you open an account, we will ask
                for your name, address, date of birth, and other information
                that will allow us to identify you. We may also ask to see your
                driver's license or other identifying documents.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeroIcons from '../components/welcome/HeroIcons.vue'
import InternalLink from '../components/globalUiComponents/InternalLink.vue'
import { params } from '../localData'
import { getAdSource } from '../services/entities/onboardingService'
import tracking from '../utils/tracking'
import Bugsnag from '../plugins/bugsnag'
import VueRecaptcha from 'vue-recaptcha'
import moment from 'moment'
import {
  isFromLiliApp,
  decodeURI,
  getCookie,
  setCookie,
} from '../services/UtilService'
import { dataLayerHandler } from '../services/analyticsService'
import mixpanel from '../plugins/mixPanel'
import shared from '../utils/shared'
import { mdiInformation } from '@mdi/js'
import zxcvbn from 'zxcvbn'
import ValidationToolTip from '../components/globalUiComponents/toolTips/ValidationToolTip.vue'
import HTTP from '../services/HttpService'
import {
  BANK_TYPE_IDS_MAP,
  INSTITUTION_IDS_MAP,
  VALIDATION_REGEX,
} from '../consts'
import { mapCustomerModelToPrefillData } from '../services/entities/customerService'
import { uploadTermsAndConditions } from '../services/SnapShotService'
import { APY, APY_EFFECTIVE_DATE } from '../consts/index'
import { getVisitorId } from '../services/fingerprintService'

export default {
  name: 'RfWelcome',
  components: {
    HeroIcons,
    VueRecaptcha,
    ValidationToolTip,
    InternalLink,
  },
  data() {
    return {
      APY,
      APY_EFFECTIVE_DATE,
      partnerId: null,
      partnerLogo: null,
      icons: {
        info: mdiInformation,
      },
      customer: {},
      firstName: null,
      lastName: null,
      partnerName: null,
      institutionData: {
        id: '',
        bankType: '',
      },
      mandatoryFields: ['email'],
      flags: {
        isLoaderShown: false,
        isFormValid: false,
        isReferee: false,
        isFetching: true,
        isPasswordShown: false,
        isPassToolTipShown: false,
        isEmailFieldReady: false,
        isPartnerFlow: false,
        didStartScroll: false,
      },
      visitorId: '',
      inputEmailRules: [
        // Indicate if the field value is falsey
        (v) => !!v || this.$t('validation.custom.email.required'),
        // Validate for an Email address scheme
        (v) =>
          VALIDATION_REGEX.EMAIL.test(v) ||
          this.$t('validation.custom.email.email'),
      ],
      passwordRules: [
        // Validate pass length
        (v) => (v && v.length >= 8) || this.$t('password.req1'),
        // check sequence
        (_v) => this.checkSequence || this.$t('password.req10'),
      ],
      firstNameRules: [
        (v) => !!v || this.$t('validation.custom.firstName.required'),
        (v) =>
          (v && v.length > 1) || this.$t('validation.custom.firstName.min'),
        (v) =>
          (v && v.length < 30) || this.$t('validation.custom.firstName.max'),
        (v) =>
          /^[a-zA-ZÀ-ÿ-_ ]*$/.test(v) ||
          this.$t('validation.custom.firstName.regex'),
      ],
      lastNameRules: [
        (v) => !!v || this.$t('validation.custom.lastName.required'),
        (v) => (v && v.length > 1) || this.$t('validation.custom.lastName.min'),
        (v) =>
          (v && v.length < 30) || this.$t('validation.custom.lastName.max'),
        (v) =>
          /^[a-zA-ZÀ-ÿ-_ ]*$/.test(v) ||
          this.$t('validation.custom.lastName.regex'),
      ],
    }
  },
  computed: {
    dynamicDisclaimer() {
      if (this.institutionData.bankType === 'CHOICE')
        return 'Choice Financial Group'
      return 'Sunrise Banks, N.A.'
    },
    isSunriseFlow() {
      return true
    },
    checkSequence() {
      let isValid = shared.validatePassword(this.customer.password || '', {
        noQwertySequences: true,
        badSequenceLength: 5,
        noSequentialLength: 4,
      })
      // This shouldn't be here, computed's shouldn't have side effects, it's disabled so our linting passed but we NEED to take care of it
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.hasBadSequence = isValid
      return isValid
    },
    score() {
      const result = zxcvbn(this.customer.password || '')
      switch (result.score) {
        case 4:
          return {
            color: '#44ca38',
            value: '99%',
          }
        case 3:
          return {
            color: '#44ca38',
            value: '75%',
          }
        case 2:
          return {
            color: '#f7be16',
            value: '50%',
          }
        case 1:
          return {
            color: '#f7be16',
            value: '35%',
          }
        case 0:
          return {
            color: '#e75858',
            value: '10%',
          }
        default:
          return {
            color: '#e75858',
            value: '0%',
          }
      }
    },
    validationToolTipData() {
      return [
        {
          isValid: this.isPassLengthValid,
          content: this.$t('password.req1'),
        },
        { isValid: this.checkSequence, content: this.$t('password.req10') },
      ]
    },
    isPassLengthValid() {
      return this.customer.password.length >= 8
    },
    isCtaEnabled() {
      return this.flags.isFormValid
    },
    isLoaderShown() {
      return this.flags.isLoaderShown
    },
    customerData() {
      return this.$store.getters['customer/data']
    },
    heroIconsData() {
      return [
        {
          iconClass: 'icon-complete-application',
          content: this.$t('notice.details1'),
        },
        { iconClass: 'icon-download-app', content: this.$t('notice.details2') },
        { iconClass: 'icon-start-spend', content: this.$t('notice.details4') },
      ]
    },
    captchaSiteKey() {
      return process.env.VUE_APP_CAPTCHA
    },
    ajaxData() {
      return {
        method: 'put',
        endPoint: params.restEndpoints.lead,
        data: {
          email: this.customer.email,
          adSource: this.customer.adSource,
          abTestNames: this.getAbTestNames(),
          referralCode: '',
          password: this.customer.password,
          ...(this.customer.firstName !== '' && {
            firstName: this.customer.firstName,
          }),
          ...(this.customer.lastName !== '' && {
            lastName: this.customer.lastName,
          }),
          bankCode: this.institutionData.id || '',
          fingerprint: this.visitorId,
        },
        self: this,
      }
    },
    referralAjaxData() {
      return {
        method: 'get',
        endPoint:
          params.restEndpoints.referralOwner + this.customer.referralCode,
        data: {
          referralCode: this.customer.referralCode,
        },
      }
    },
    persistAjaxData() {
      return {
        method: 'get',
        endPoint: '',
        // params.restEndpoints.ssn + id from local + /status
      }
    },
    formFieldsErrors() {
      return this.$store.getters['errors/fieldErrors']
    },
    heroContent() {
      return this.flags.isReferee
        ? `<h2 class="main-header">${this.customer.referee} seems to think a Lili account could help you and your business. we totally agree 😉</h2>`
        : this.$t('notice.title')
    },
    obData() {
      return this.$store.getters['onboarding/data']
    },
    isPartnerFlow() {
      return this.$store.getters['onboarding/isPartnerFlow']
    },
    isMobile() {
      return this.$store.getters['onboarding/isMobile']
    },
    isDNB() {
      let dnbIds = [
        /* Integ ids */ '8a4ea8ca-470f-4be7-a2ef-69508be415ec',
        '8b745cdb-03bf-4dad-a64d-0dd6638d0848',
        /* Prod ids */ 'cc2f7c20-4c39-4272-b538-588361dee3e6',
        'c3f12798-00de-47ac-9338-e674470ea66e',
      ]
      return dnbIds.includes(this.partnerId)
    },
  },
  watch: {
    formFieldsErrors(errorsMap) {
      for (let field in errorsMap) {
        if (errorsMap[field]) {
          dataLayerHandler(this, 'start', 'start screen loaded')
          return
        }
      }
    },
  },
  async created() {
    this.visitorId = await getVisitorId()
  },
  async beforeMount() {
    /** Get institution data [Choice / Sunrise] */
    await this.handleInstitution()
    /** --------------------------------------- */
    // this.handleFingerPrint()
    let shouldPersist = this.$route.query.should_persist
    if (shouldPersist !== 'undefined' && !shouldPersist) {
      this.deletePersistData()
    }
    if (
      JSON.parse(localStorage.getItem('shouldRedirect')) &&
      !isFromLiliApp()
    ) {
      localStorage.setItem('shouldRedirect', false)
      window.location.href = 'https://lili.co/'
    }
    let isPersisting = await this.checkPersistData()
    // If there is persist data, avoid continue of the flow
    if (isPersisting) return
    localStorage.setItem('lastStep', 'welcome')
    this.$store.commit('onboarding/setKeyValue', {
      prop: 'editMode',
      value: false,
    })
    // Start analytics flow
    tracking.startOb(this)
    // Get shalow copy of customer data in State and mutate it localy
    this.customer = this.customerData
    // Temporary to Combine old customerDetails Analytics data with the global store
    this.customer = { ...this.customer, ...this.$customerDetails }
    // Get adSource value from OB service
    this.customer.adSource = getAdSource(this)
    // Get referee name
    await this.getReferralName()
    // Update customer state
    this.$store.commit('customer/setMultiKeyValues', this.customer)

    await this.getAndSetPartnerCustomizationData()
    dataLayerHandler(this, 'start', 'start screen loaded')
  },
  mounted() {
    window.scrollTo(0, 0)
    window.addEventListener('click', () => {
      if (this.flags.isPassToolTipShown) {
        this.flags.isPassToolTipShown = false
      }
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  updated() {
    this.$nextTick(function () {
      // Check if need to validate form on mounted
      if (this.shouldValidateOnMounted()) {
        this.validateForm()
      }
    })
  },
  methods: {
    handleScroll() {
      if (this.flags.didStartScroll) {
        return
      }
      mixpanel.track('Act on sign up page', {
        Action: 'swipe down',
      })
      this.flags.didStartScroll = true
    },

    async handleInstitution() {
      const { token } = this.$route.query

      if (token) return

      // if there is institutionId parameter/cookie - use it in query string
      const qInstitutionId = getCookie('institutionId')
      this.flags.isLoaderShown = true
      try {
        const institutionData = await HTTP.get(
          `v3/onboarding/institution?institutionId=${qInstitutionId}`,
          {},
          null,
          true
        )
        const { institutionId } = institutionData
        /** Set cookie institutionId for 30 Days */
        setCookie('institutionId', institutionId, 30, true)
        this.institutionData = {
          id: institutionId,
          bankType: BANK_TYPE_IDS_MAP[institutionId],
        }
        /** Add this param to customer model, so we can use it in last screen */
        this.$store.commit('customer/setKeyValue', {
          prop: 'institutionData',
          value: this.institutionData,
        })
        this.flags.isLoaderShown = false
      } catch (e) {
        // TODO Handle error flow @Reem
        this.flags.isLoaderShown = false
      }
    },
    submitForm() {
      if (this.flags.isLoaderShown) return
      // If user click submit when form is not valid, the operation below will indicate the errors then return
      if (!this.flags.isFormValid) {
        this.$refs.form.validate()
        return
      }
      // Toggle CTA button loader animation
      this.updateLoader(true)
      tracking.buildAdSource(this)
      // Update adSource value from customerDetails into local customer state
      this.customer.adSource = this.$customerDetails.adSource
      // Update customer state
      this.$store.commit('customer/setMultiKeyValues', this.customer)
      // Execute recaptcha validation
      this.handleRecaptcha('exec')
    },
    async onVerify(recaptchaAnswer) {
      this.handleDecodeAdSource()
      try {
        // Initiate AJAX to update
        let res = await this.$store.dispatch(
          'customer/updateCustomer',
          {
            ...this.ajaxData,
            header: {
              headerName: params.httpHeaders.recaptcha,
              headerValue: recaptchaAnswer,
            },
          },
          this
        )
        this.updateLoader(true)
        tracking.enterEmail(this)
        const {
          externalId,
          requireAuthentication,
          accessToken,
          availablePromoCodes,
          isNonUsSupported,
          emailMfaActive,
          loginResponseCustomData: { stateToken },
        } = res

        if (emailMfaActive) {
          mixpanel.track('Act on sign up page', {
            Action: 'Continue to email verification',
          })
        }
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'mfaStateToken',
          value: stateToken,
        })
        if (!emailMfaActive) {
          await uploadTermsAndConditions(externalId, accessToken, 'GET_STARTED')
        }
        window.hj('identify', externalId, {
          isFromLiliApp: isFromLiliApp(),
          customerId: externalId,
          flowId: tracking.getAbTestFlowId(),
        })
        this.handleAnalytics(externalId)
        this.customer.customerId = externalId
        this.customer.accessToken = accessToken
        this.customer.availablePromoCodes = availablePromoCodes
        this.customer.isNonUsSupported = isNonUsSupported

        // The moreData flag indicates that we can pre-fill
        // Some of the customer data from API
        if (res && res.moreData && accessToken && !requireAuthentication) {
          // this will set pre-filled data to the customer model
          await this.getAndSetCustomerPreFilledData(res.externalId, accessToken)
        }

        // Update the customer model on the global state
        this.$store.commit('customer/setMultiKeyValues', this.customer)

        // DELETE AFTER FINISH REFACTOR (Also update the old CustomerModel)
        this.$customerDetails = { ...this.$customerDetails, ...this.customer }

        let nextRouteName = this.flags.isPartnerFlow ? 'phone' : 'intro'
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'tempRequireAuth',
          value: requireAuthentication,
        })
        if (emailMfaActive) nextRouteName = 'email-verification'
        else if (this.isEditMode) nextRouteName = 'review'
        else if (requireAuthentication) nextRouteName = 'login'
        this.$router.push({ name: nextRouteName })
      } catch (err) {
        this.updateLoader(false)
        this.handleRecaptcha('reset')
        throw err
      }
    },
    handleGetStarted() {
      mixpanel.track('Act on sign up page', {
        Action: 'Clicked Already Started',
      })
      this.$router.push('/ob/continue-onboarding')
    },
    handleAnchorClick(type) {
      switch (type) {
        case 'terms':
          mixpanel.track('Click TnC', {
            isClicked: true,
          })
          break
        case 'privacy':
          mixpanel.track('Click Privacy Policy', {
            isClicked: true,
          })
          break
      }
    },
    isAllrequiredFieldsDirty() {
      let mode = true
      const fields = ['password', 'email']
      fields.forEach((field) => {
        if (!this.customer[field]) {
          mode = false
        }
      })
      return mode
    },
    async onCaptchaError() {
      this.updateLoader(false)
      this.handleRecaptcha('reset')
    },
    validateForm() {
      if (!this.isAllrequiredFieldsDirty() || !this.$refs.form) return
      let isValid = this.$refs.form.validate()
      this.flags.isFormValid = isValid
    },
    clearFieldError(field) {
      this.$store.dispatch('errors/clearSpecificFieldError', [
        'defaultError',
        field,
      ])
    },
    updateLoader(isLoading) {
      this.flags.isLoaderShown = isLoading
    },
    async handleAnalytics(externalId) {
      if (!externalId) {
        Bugsnag.notify(`Got bad externalId parameter: ${externalId}`)
        await mixpanel.reset()
      } else {
        await mixpanel.identify(externalId)
        tracking.startTrial(this)
        await mixpanel.people.set({
          canSelectPlan: true,
          isFromLiliApp: isFromLiliApp(),
          defaultPlanSelected: 'Smart',
          flowId: tracking.getAbTestFlowId(),
        })
      }
      // insert userId to bugsnag
      Bugsnag.setUser(externalId)
      // GTM dataLayer
      window.dataLayer &&
        window.dataLayer.push({
          customer_external_id: externalId || '',
        })
    },
    handleRecaptcha(method) {
      switch (method) {
        case 'reset':
          this.$refs.recaptcha.reset()
          break
        case 'exec':
          this.$refs.recaptcha.execute()
          break

        default:
          break
      }
    },
    shouldValidateOnMounted() {
      let isValidating = true
      this.mandatoryFields.forEach((field) => {
        if (!this.customer[field]) {
          isValidating = false
        }
      })
      return isValidating
    },
    async getReferralName() {
      if (!this.customer.customerId) {
        this.flags.isFetching = false
        return
      }
      try {
        let res = await this.$store.dispatch('customer/get', {
          ...this.referralAjaxData,
        })
        this.flags.isFetching = false
        if (res && res !== 'Us') {
          this.customer.referee = res
          this.flags.isReferee = true
        }
      } catch (error) {
        // Add bug snag in customer module.
        this.flags.isFetching = false
        this.customer.referee = ''
      }
    },
    async checkPersistData() {
      let persistData = JSON.parse(localStorage.getItem('persistData'))
      // AccessToken from storage can be Expired*
      let lastStep = localStorage.getItem('lastStep')
      if (!persistData || !persistData.token || !persistData.id) return
      try {
        let customerData = await this.$store.dispatch(
          'customer/get',
          {
            method: 'get',
            endPoint: params.restEndpoints.address + persistData.id,
            header: {
              headerName: params.httpHeaders.auth,
              headerValue: 'Bearer ' + persistData.token,
            },
          },
          this
        )
        // If token expired customerData will be falsey - Avoid flow & delete from localStorage
        if (!customerData.email) {
          this.deletePersistData()
          return
        }
        customerData = {
          ...customerData,
          customerId: persistData.id,
          phoneNumber: customerData.phoneNumber
            ? customerData.phoneNumber.substr(2)
            : '',
          accessToken: persistData.token,
          birthDateNotFormatted: customerData.birthDate
            ? moment.parseZone(customerData.birthDate).format('MM/DD/YYYY')
            : '',
          pro: persistData.pro,
        }
        customerData && this.handleAnalytics(customerData.customerId)
        this.customer = customerData
        this.$store.commit('customer/setMultiKeyValues', this.customer)
        if (lastStep !== 'welcome') {
          this.$store.commit('onboarding/setKeyValue', {
            prop: 'persistLastStep',
            value: lastStep,
          })
          this.$router.push({
            name: lastStep,
            params: { shouldDisableBackBtn: true },
          })
        }
        return true
      } catch (err) {
        this.deletePersistData()
      }
    },
    deletePersistData() {
      localStorage.removeItem('persistData')
    },
    handleDecodeAdSource() {
      try {
        // Get the adSource as live object
        const adSource = JSON.parse(this.customer.adSource)
        if (!adSource) return
        // Export utm_partner and save it as variable
        const rawUtmPartner = adSource.utm_partner
        // Delete the utm_partner from the original adSource object
        delete adSource.utm_partner
        // Decode the adSource without the utm_param
        let decodedAdSource = decodeURI(JSON.stringify(adSource), 2)
        // Re-assign the utm_partner
        decodedAdSource = JSON.parse(decodedAdSource)
        decodedAdSource['utm_partner'] = rawUtmPartner
        // Set customer adSource the new decoded one
        this.customer.adSource = JSON.stringify(decodedAdSource)
      } catch (error) {
        console.error(error)
      }
    },
    getAbTestNames() {
      const names = []
      if (this.customer.isFeeABtestEnrolled) {
        names.push('BUSINESS_DETAILS_TEST_V1')
      }
      return names
    },
    async getAndSetPartnerCustomizationData() {
      const { token } = this.$route.query

      if (!token) return
      this.flags.isFetching = true
      try {
        const {
          partnerId,
          email,
          partnerName,
          firstName,
          lastName,
          institutionId,
        } = await HTTP.get(`v3/onboarding?token=${token}`)

        if (!partnerId) {
          this.flags.isFetching = false
          return
        }
        this.partnerId = partnerId

        this.flags.isPartnerFlow = true
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'isPartnerFlow',
          value: true,
        })
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'partnerToken',
          value: token,
        })
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'partnerName',
          value: partnerName,
        })
        this.partnerLogo = `https://assets.lili.co/connect/${partnerId}/ob_logo.png`
        if (email) {
          this.customer.email = email
          this.flags.isEmailFieldReady = true
        }
        this.customer.firstName = firstName
        this.customer.lastName = lastName
        this.partnerName = partnerName
        if (institutionId) {
          this.institutionData = {
            id: institutionId,
            bankType: BANK_TYPE_IDS_MAP[institutionId],
          }
          /** Add this param to customer model, so we can use it in last screen */
          this.$store.commit('customer/setKeyValue', {
            prop: 'institutionData',
            value: this.institutionData,
          })
        } else {
          const sunriseId = INSTITUTION_IDS_MAP.SUNRISE
          this.institutionData = {
            id: sunriseId,
            bankType: BANK_TYPE_IDS_MAP[sunriseId],
          }
          /** Add this param to customer model, so we can use it in last screen */
          this.$store.commit('customer/setKeyValue', {
            prop: 'institutionData',
            value: this.institutionData,
          })
        }
      } finally {
        this.flags.isFetching = false
      }
    },

    async getAndSetCustomerPreFilledData(customerId, accessToken) {
      const customerDataResults = await HTTP.get(
        `v3/secureonboarding/user/${customerId}`,
        null,
        {
          headerName: params.httpHeaders.auth,
          headerValue: 'Bearer ' + accessToken,
        }
      )
      if (
        customerDataResults.customerData &&
        customerDataResults.customerData.partner
      ) {
        this.$store.commit('onboarding/setKeyValue', {
          prop: 'isPartnerFlow',
          value: true,
        })
      }
      // merge the pre-filled data with the local customer model
      const mappedData = mapCustomerModelToPrefillData(
        customerDataResults,
        this.institutionData
      )
      this.customer = {
        ...this.customer,
        ...mappedData,
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/rf_welcome.vue